const RTF = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

const UNITS: Array<[Intl.RelativeTimeFormatUnit, number]> = [
  ['year', 60 * 60 * 24 * 365],
  ['month', 60 * 60 * 24 * 30],
  ['week', 60 * 60 * 24 * 7],
  ['day', 60 * 60 * 24],
  ['hour', 60 * 60],
  ['minute', 60],
  ['second', 1],
];

/**
 * Format an ISO datetime as "3 minutes ago" / "in 2 days".
 */
export function relativeTime(iso: string | undefined | null, now: Date = new Date()): string {
  if (!iso) return '-';
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return '-';
  const deltaSec = (t - now.getTime()) / 1000;
  for (const [unit, secondsPerUnit] of UNITS) {
    if (Math.abs(deltaSec) >= secondsPerUnit || unit === 'second') {
      return RTF.format(Math.round(deltaSec / secondsPerUnit), unit);
    }
  }
  return RTF.format(Math.round(deltaSec), 'second');
}

export function shortDate(iso: string | undefined | null): string {
  if (!iso) return '-';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export function fullDateTime(iso: string | undefined | null): string {
  if (!iso) return '-';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}
